import { useTranslation } from 'react-i18next'
import { ContentSection } from '../components/content-section'
import { ThemeForm } from './theme-form'

export function SettingsTheme() {
  const { t } = useTranslation('common')

  return (
    <ContentSection
      title={t('settings.theme')}
      desc={t('settings.themeDescription')}
    >
      <ThemeForm />
    </ContentSection>
  )
}
